module.exports = __webpack_public_path__ + "static/media/icon_trend-down.73a7a91e.svg";